import {Link, useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import headerFile from "./header.txt"
import APPS from "../config/apps";
import 'normalize.css';

const FeedbackPage = () => {
    const [header, setHeader] = useState('');
    const [searchParams] = useSearchParams();
    const [app, setApp] = useState(APPS.find(a => a.id === searchParams.get('app'))?.id ?? 'other');
    const [message, setMessage] = useState('');
    const [email, setEmail] = useState('');
    const [website, setWebsite] = useState('');
    const [status, setStatus] = useState('idle');
    const [errorMsg, setErrorMsg] = useState('');

    useEffect(() => {
        fetch(headerFile).then(response => response.text()).then(setHeader);
    }, []);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (message.trim() === '') return;
        setStatus('submitting');
        try {
            const response = await fetch('/api/feedback', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({app, message, email, website}),
            });
            if (response.ok) {
                setStatus('success');
            } else {
                const data = await response.json().catch(() => ({}));
                setErrorMsg(data.error || 'Something went wrong, please try again later.');
                setStatus('error');
            }
        } catch (error) {
            setErrorMsg('Something went wrong, please try again later.');
            setStatus('error');
        }
    };

    return (<div>
        <br/><br/><Link style={styles.link} to={'/'}>Back to Artembo's workplace</Link>
        <pre style={styles.header}>
            {header}
        </pre>
        <div style={styles.container}>
            <h2 style={styles.title}>Feedback</h2>
            {status === 'success'
                ? <p>Thanks! Your message has been sent.</p>
                : <form onSubmit={handleSubmit} style={styles.form}>
                    <label style={styles.label}>
                        What is this about?
                        <select style={styles.input} value={app} onChange={e => setApp(e.target.value)}>
                            {APPS.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
                        </select>
                    </label>
                    <label style={styles.label}>
                        Message
                        <textarea
                            style={{...styles.input, ...styles.textarea}}
                            value={message}
                            onChange={e => setMessage(e.target.value)}
                            required
                            maxLength={4000}
                        />
                    </label>
                    <label style={styles.label}>
                        Email (optional, if you want a reply)
                        <input
                            style={styles.input}
                            type="email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                        />
                    </label>
                    <div style={styles.honeypot} aria-hidden="true">
                        <input
                            name="website"
                            type="text"
                            tabIndex={-1}
                            autoComplete="off"
                            value={website}
                            onChange={e => setWebsite(e.target.value)}
                        />
                    </div>
                    {status === 'error' && <p style={styles.error}>{errorMsg}</p>}
                    <button style={styles.button} type="submit" disabled={status === 'submitting'}>
                        {status === 'submitting' ? 'Sending...' : 'Send'}
                    </button>
                </form>}
            <p style={styles.privacy}>
                Privacy: this form collects only what you submit — the message, the selected
                app, and your email if you choose to leave one. Submissions are delivered
                privately to the site owner and used only to respond to your feedback.
                This site uses no cookies or trackers.
            </p>
        </div>
    </div>);
}


const styles = {
    link: {
        padding: "0 0 20px 20px",
        color: "black"
    },
    header: {
        padding: "20px 20px 0 20px",
        whiteSpace: "pre",
        overflow: "auto",
        scrollbarWidth: "none",
        fontSize: "clamp(16px, 4vw, 28px)",
        lineHeight: "1.15",
        margin: "0"
    },
    container: {
        padding: "0 20px 20px 20px",
        fontFamily: "monospace",
        maxWidth: "480px"
    },
    title: {
        margin: "0 0 16px 0"
    },
    form: {
        display: "flex",
        flexDirection: "column",
        gap: "12px"
    },
    label: {
        display: "flex",
        flexDirection: "column",
        gap: "4px"
    },
    input: {
        fontFamily: "monospace",
        fontSize: "14px",
        padding: "6px",
        border: "1px solid black",
        borderRadius: "0",
        background: "white"
    },
    textarea: {
        minHeight: "120px",
        resize: "vertical"
    },
    honeypot: {
        position: "absolute",
        left: "-9999px"
    },
    error: {
        color: "darkred",
        margin: "0"
    },
    privacy: {
        marginTop: "24px",
        fontSize: "12px",
        color: "#555",
        lineHeight: "1.5"
    },
    button: {
        fontFamily: "monospace",
        fontSize: "14px",
        padding: "8px",
        border: "1px solid black",
        borderRadius: "0",
        background: "white",
        cursor: "pointer",
        alignSelf: "flex-start",
        minWidth: "120px"
    }
}


export default FeedbackPage
